module.exports = __webpack_public_path__ + "static/media/teamPhoto.228b0ffb.png";